<template>
  <!-- 🔹 LAYOUT DINÂMICO -->
  <component :is="layoutComponent">
    <router-view />
  </component>

  <!-- 🔥 LOADING GLOBAL -->
  <LoadingOverlayComponent
    :visible="loadingState.visible"
    :progress="loadingState.progress"
    :title="loadingState.title"
    :message="loadingState.message"
    :hint="loadingState.hint"
  />
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

/* ================================
   🧱 LAYOUTS
================================ */
import AuthLayout from "@/layouts/AuthLayout.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";

/* ================================
   🔥 LOADING GLOBAL
================================ */
import LoadingOverlayComponent from "@/components/global/LoadingOverlayComponent.vue";
import { useGlobalLoading } from "@/composables/useGlobalLoading";

/* ================================
   🧭 ROTA ATUAL
================================ */
const route = useRoute();

/* ================================
   🧱 RESOLUÇÃO DE LAYOUT
================================ */
const layoutComponent = computed(() => {
  switch (route.meta?.layout) {
    case "auth":
      return AuthLayout;
    case "DashboardLayout":
      return DashboardLayout;
    default:
      return DefaultLayout;
  }
});

/* ================================
   🔄 ESTADO GLOBAL DE LOADING
================================ */
const { loadingState } = useGlobalLoading();
</script>
